import { Card, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { checkSpeciality } from "../../utils/checkSpeciality";
import ExpedienteClinicoMex from "../conferencedoctor/ExpedienteClinicoMex";
import FichaEpidemiologicaColombia from "../doctor/FichaEpidemiologicaColombia";
import ProvArchivos from "../proveedor/ProvArchivos";
import ProvHistoriaClinica from "../proveedor/ProvHistoriaClinica";
import ProvHistorialCitas from "../proveedor/ProvHistorialCitas";

function DetalleCitaAnexos1({t, cita, auth, companyType, setShowModalServer}){


    return(
        <Card className="shadow-1">
            <Card.Body>
                <Tabs defaultActiveKey="historial_citas" className="tabs-conference" transition={false}>
                    <Tab eventKey="historial_citas" title={t('historial_citas')}>
                        {
                            (cita.scheduleDTO.doctor.id && cita.patientDTO?.id) && 
                            <ProvHistorialCitas
                                cita={cita} 
                                paciente={cita.patientDTO} 
                                idDoctor={cita.scheduleDTO.doctor.id} 
                                idPaciente={cita.patientDTO.id} 
                                showAddCita={ false }
                            /> 
                        }
                    </Tab>
                    <Tab 
                        eventKey="historia_clinica" 
                        title={
                            checkSpeciality(cita.idSpeciality) ?
                            "Resumen de consulta" :
                            t('historia_clinica')
                        }>
                            <ProvHistoriaClinica
                                appointmentId={cita.id} 
                                idHM={cita.medicalHistoryDTO?.id} 
                                auth={auth}
                                idSpeciality={cita.idSpeciality}
                                readOnly={true}  
                                setShowModalServer={(setShowModalServer)}    
                                setReload={() => {}}
                                setCita={() => {}}                          
                            />
                    </Tab>
                    <Tab eventKey="archivos" title="Archivos">
                        <ProvArchivos 
                            appointmentId={cita.id} 
                            auth={auth} 
                            readOnly={true}
                        />
                    </Tab>
                    {companyType !== "colombia" && 
                    <Tab eventKey="expediente_clinico" title="Expediente clínico">
                        <ExpedienteClinicoMex 
                            cita={cita} 
                            auth={auth} 
                            readOnly={true}
                        />
                    </Tab>}
                    {
                        companyType === "colombia" && 
                        <Tab eventKey="fichaepidemiologica" title="Ficha epidemiológica">
                            <FichaEpidemiologicaColombia
                                appointmentId={cita.id} 
                                idHM={cita.epidemiologicalFileDTO?.id} 
                                auth={auth}
                                idSpeciality={cita.idSpeciality}
                                readOnly={true}
                            />
                        </Tab>
                    }
                </Tabs>
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(DetalleCitaAnexos1)